import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

export const MESSAGES_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/messages/views/messages/messages.component').then((m) => m.MessagesComponent),
        data: { routePath: RoutePath.MESSAGES },
    },
];
